'use client';

import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

import { useInputContext } from './input-context';

export type LabelProps = ComponentProps<'label'> & {
  required?: boolean;
};

export function Label({ children, required, className, ...props }: LabelProps) {
  const { id } = useInputContext();

  return (
    <label
      className={twMerge(
        'pointer-events-none absolute left-4',

        'top-[calc(100%-1rem)] -translate-y-1/2',

        'bg-transparent py-2 text-base font-light',

        'transition-[top,left,transform,color,font-size,padding] duration-300 ease-out',

        'group-focus-within:top-1.5 group-data-[has-value]:top-1.5',
        'group-focus-within:left-1.5 group-data-[has-value]:left-1.5',
        'group-focus-within:py-2 group-data-[has-value]:py-2',
        'group-focus-within:text-sm group-data-[has-value]:text-sm',
        'group-focus-within:scale-90 group-data-[has-value]:scale-90',

        className,
      )}
      htmlFor={id}
      {...props}
    >
      {children}

      {required && (
        <span className="text-zmyle-primary ml-1" aria-hidden="true">
          *
        </span>
      )}
    </label>
  );
}
